(() => {
  const pauseExternalMedia = (item) => {
    item.querySelectorAll('iframe[src]').forEach((iframe) => {
      let url;
      try { url = new URL(iframe.getAttribute('src'), window.location.href); } catch { return; }
      if (!['https:', 'http:'].includes(url.protocol)) return;
      const youtube = ['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(url.hostname) && url.pathname.startsWith('/embed/');
      const vimeo = url.hostname === 'player.vimeo.com' && url.pathname.startsWith('/video/');
      if (!youtube && !vimeo) return;
      if (youtube && url.searchParams.get('enablejsapi') !== '1' && iframe.getAttribute('enablejsapi') !== 'true') {
        url.searchParams.set('autoplay', '0');
        iframe.setAttribute('src', url.toString());
        return;
      }
      const message = youtube ? { event: 'command', func: 'pauseVideo', args: [] } : { method: 'pause' };
      iframe.contentWindow?.postMessage(JSON.stringify(message), url.origin);
    });
  };
  const clampQuantity = (value, minimum, maximum, increment) => {
    const min = Math.max(1, Number(minimum) || 1);
    const step = Math.max(1, Number(increment) || 1);
    const max = maximum === '' ? Infinity : Math.max(min, Number(maximum) || min);
    const requested = Number(value);
    const bounded = Math.min(max, Math.max(min, Number.isFinite(requested) ? requested : min));
    return min + Math.floor((bounded - min) / step) * step;
  };
  const initProduct = (section) => {
    if (section.dataset.rrReady) return;
    section.dataset.rrReady = 'true';
    const gallery = section.querySelector('[data-rr-gallery]');
    const media = [...section.querySelectorAll('[data-rr-media]')];
    const thumbs = [...section.querySelectorAll('[data-rr-thumbnail]')];
    let activeMediaId = null;
    const showMedia = (id) => {
      if (!media.some((item) => item.dataset.rrMedia === String(id))) return;
      media.forEach((item) => {
        const active = item.dataset.rrMedia === String(id);
        item.hidden = !active;
        if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
        if (!active && item.dataset.rrMedia === activeMediaId) pauseExternalMedia(item);
      });
      activeMediaId = String(id);
      thumbs.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rrThumbnail === String(id))));
    };
    if (gallery && media.length) {
      gallery.dataset.enhanced = 'true';
      showMedia(section.dataset.currentMedia || media[0].dataset.rrMedia);
      thumbs.forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.rrThumbnail)));
    }
    const selector = section.querySelector('[data-rr-variant]');
    if (!selector) return;
    selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      section.querySelector('[data-rr-price]').textContent = option.dataset.price;
      const compare = section.querySelector('[data-rr-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      const availability = section.querySelector('[data-rr-availability]');
      availability.dataset.available = String(available);
      availability.textContent = available ? availability.dataset.availableLabel : availability.dataset.soldOutLabel;
      const add = section.querySelector('[data-rr-add]');
      if (add) {
        add.disabled = !available;
        const addLabel = add.querySelector('[data-rr-add-label]');
        if (addLabel) addLabel.textContent = available ? add.dataset.addLabel : add.dataset.soldOutLabel;
      }
      const accelerated = section.querySelector('[data-rr-accelerated]');
      if (accelerated) accelerated.hidden = !available;
      const sku = section.querySelector('[data-rr-sku]');
      sku.textContent = option.dataset.sku || '';
      section.querySelector('[data-rr-sku-wrap]').hidden = !option.dataset.sku;
      const quantity = section.querySelector('[data-rr-quantity]');
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = clampQuantity(quantity.value, quantity.min, quantity.max, quantity.step);
      if (option.dataset.media) showMedia(option.dataset.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    }, { capture: true });
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-rr-product]').forEach(initProduct);
    scope.querySelectorAll('[data-rr-sort]').forEach((select) => {
      if (select.dataset.rrReady) return;
      select.dataset.rrReady = 'true';
      const button = select.parentElement.querySelector('.rr-sort__submit');
      if (button) button.hidden = true;
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
    scope.querySelectorAll('[data-rr-filters]').forEach((details) => {
      if (details.dataset.rrReady) return;
      details.dataset.rrReady = 'true';
      const breakpoint = window.matchMedia('(min-width: 901px)');
      const sync = () => { details.open = breakpoint.matches; };
      sync();
      breakpoint.addEventListener('change', sync);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
